/* unplugin-vue-components disabled */import script from "./forumSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./forumSearch.vue?vue&type=script&setup=true&lang=js"

import "./forumSearch.vue?vue&type=style&index=0&id=1f70198e&scoped=true&lang=scss"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f70198e"]])

export default __exports__